import { render, staticRenderFns } from "./BorderInput.vue?vue&type=template&id=7181d221&"
import script from "./BorderInput.vue?vue&type=script&lang=js&"
export * from "./BorderInput.vue?vue&type=script&lang=js&"
import style0 from "./BorderInput.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports